import { useCommunityFetcher } from './useCommunityFetcher';

export const PIN_POST_ACTION = '/pin_community_post';
export const PIN_FETCHER_KEY = 'pin-community-post';

const QUERY_KEY = ['community-posts'];

export const usePinPostFetcher = () => {
  const { fetcher } = useCommunityFetcher(PIN_FETCHER_KEY, { queryKey: QUERY_KEY });
  return { fetcher };
};
